import { toast } from "react-toastify";

import {
  PutExperienceScheduleRequestBodyType,
  PutExperienceScheduleResponseBodyType,
} from "@intelligems/ig-types";
import { useDialogs } from "@src/hooks/dialog";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";
import {
  experienceKeys,
  invalidateModuleExperienceListQueries,
  scheduleKeys,
} from "../queryKeys";
import { ApiRequest } from "../types/api";

const putExperienceSchedule = async (
  data: ApiRequest<PutExperienceScheduleRequestBodyType>
) => {
  const resp = await api.put<PutExperienceScheduleResponseBodyType>(
    `/v2/schedules/experiences`,
    data.body
  );
  return resp.data;
};

export const usePutExperienceSchedule = () => {
  const queryClient = useQueryClient();
  const { closeDialog } = useDialogs();

  return useMutation<
    PutExperienceScheduleResponseBodyType,
    Error,
    ApiRequest<PutExperienceScheduleRequestBodyType>,
    any
  >({
    mutationFn: async (
      data: ApiRequest<PutExperienceScheduleRequestBodyType>
    ) => putExperienceSchedule(data),
    onSuccess: async (data, payload) => {
      const experienceId = payload.body[0].experienceId;

      await queryClient.setQueryData(scheduleKeys.one(experienceId), data);

      await queryClient.invalidateQueries({
        queryKey: experienceKeys.one(experienceId),
      });
      invalidateModuleExperienceListQueries(queryClient);

      await queryClient.invalidateQueries({
        queryKey: experienceKeys.experimentList,
      });
      await queryClient.invalidateQueries({
        queryKey: experienceKeys.homeOverviewPersonalizationList,
      });

      await queryClient.invalidateQueries({
        queryKey: scheduleKeys.all,
      });

      toast.success("Schedule Updated");
      closeDialog("scheduleTest");
      closeDialog("schedulePersonalization");
    },
  });
};
